import { create } from "zustand";
import axios from "axios";
import { customerChat } from "../api_layer/api";
import { downloadChat } from "../api_layer/api";
import { call } from "../api_layer/api";
import { count } from "../api_layer/api";

const customerChatUseStore = create((set) => ({
  chatData: [],
  chatDownload: [],
  countPage: "1",
  isLoading: false,
  chatLoading: false,
  error: null,
  callResponse: null,
  fetchChatData: async (page) => {
    try {
      set({ chatLoading: true, error: null });
      const response = await customerChat(page);
      set({ chatData: response.data, chatLoading: false });
    } catch (error) {
      set({ error: error.message, chatLoading: false });
    }
  },
  fetchCount: async () => {
    try {
      set({ CountLoading: true, error: null });
      const response = await count();
      set({ countPage: response.data, CountLoading: false });
    } catch (error) {
      set({ error: error.message, CountLoading: false });
    }
  },
  fetchDownloadData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await downloadChat();
      set({ chatDownload: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchCall: async (data) => {
    try {
      set({ error: null });
      const response = await call(data);
      set({ callResponse: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export default customerChatUseStore;
